import { configureChains, createConfig } from "wagmi";
import { mainnet, sepolia } from "wagmi/chains";
import { jsonRpcProvider } from "wagmi/providers/jsonRpc";
import { InjectedConnector } from "wagmi/connectors/injected";
import { CoinbaseWalletConnector } from "wagmi/connectors/coinbaseWallet";
import { WalletConnectConnector } from "wagmi/connectors/walletConnect";

import { OSHAR_COLLECTION_NAME, OSHAR_REAL_ESTATE_CHAIN_ID, SEPOLIA_CHAIN_ID } from "./contractConfig";
import { getChainLabel } from "../../config/chainEnv";

const walletConnectProjectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;
const DEFAULT_SEPOLIA_RPC_URL = "https://ethereum-sepolia-rpc.publicnode.com";
const envSepoliaRpcUrl = process.env.REACT_APP_SEPOLIA_RPC_URL;
const sepoliaRpcUrl = envSepoliaRpcUrl || DEFAULT_SEPOLIA_RPC_URL;
if (!envSepoliaRpcUrl) {
  // eslint-disable-next-line no-console
  console.warn(
    "Missing REACT_APP_SEPOLIA_RPC_URL in frontend .env, using fallback public RPC."
  );
}

const DEFAULT_MAINNET_RPC_URL = "https://eth.llamarpc.com";
const envMainnetRpcUrl =
  process.env.REACT_APP_MAINNET_RPC_URL && String(process.env.REACT_APP_MAINNET_RPC_URL).trim();
const mainnetRpcUrl = envMainnetRpcUrl || DEFAULT_MAINNET_RPC_URL;

const { chains, publicClient, webSocketPublicClient } = configureChains(
  [mainnet, sepolia],
  [
    jsonRpcProvider({
      rpc: (chain) => {
        if (chain.id === mainnet.id) return { http: mainnetRpcUrl };
        return { http: sepoliaRpcUrl };
      },
    }),
  ]
);

const connectors = [new InjectedConnector({ chains }), new CoinbaseWalletConnector({
    chains,
    appName: OSHAR_COLLECTION_NAME,
  })];

if (walletConnectProjectId) {
  connectors.push(
    new WalletConnectConnector({
      chains,
      options: {
        projectId: walletConnectProjectId,
        showQrModal: true,
        metadata: {
          name: OSHAR_COLLECTION_NAME,
          description: "Oshar VR real estate wallet connection",
          url: "https://treydora.com",
          icons: [],
        },
      },
    })
  );
}

export const wagmiConfig = createConfig({
  autoConnect: false,
  connectors,
  publicClient,
  webSocketPublicClient,
});

export const getNetworkName = (chainId) => {
  if (!chainId) return "Not connected";
  return getChainLabel(chainId);
};

export const isWrongNetwork = (chainId) =>
  Boolean(chainId) && Number(chainId) !== OSHAR_REAL_ESTATE_CHAIN_ID;

export const hasWalletConnectSupport = Boolean(walletConnectProjectId);
